module.exports = __webpack_public_path__ + "static/img/tat.b32f3431.png";